import {
  HTTP_GETMONTHBUDGET_FETCHING,
  HTTP_GETMONTHBUDGET_SUCCESS,
  HTTP_GETMONTHBUDGET_FAILED,
  HTTP_RESET_GETMONTHBUDGET,
} from "src/Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETMONTHBUDGET_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETMONTHBUDGET_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETMONTHBUDGET_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
